import Vue from "vue"
import Router from "vue-router"
import { createRouter, createWebHistory } from 'vue-router'

import Archives from "@/pages/Archives/archives.vue"
import Leading from "@/pages/Archives/leading.vue"
import Organization from "@/pages/Archives/organization.vue"
import Home from "@/pages/Home/home.vue"
import Forum from "@/pages/Forum/forum.vue"
import ForumClassroom from "@/pages/Forum/ForumClassroom.vue"
import ForumOutside from "@/pages/Forum/ForumOutside.vue"
import ForumWarning from "@/pages/Forum/ForumWarning.vue"
import CompanyIntro from "@/pages/CompanyIntro/companyIntro.vue"
import Risk from "@/pages/Risk/Risk.vue"
import SiXiang from "@/pages/Risk/SiXiang.vue"
import ZhiDu from "@/pages/Risk/ZhiDu.vue"
import ZhiZe from "@/pages/Risk/ZhiZe.vue"
import ProductClassify from "@/pages/ProductClassify/productClassify.vue"
import ContactUs from "@/pages/ContactUs/contactUs.vue"
import Investigate from "@/pages/Investigate/Investigate.vue"
import ZhiJi from "@/pages/Investigate/ZhiJi.vue"
import ZhiFa from "@/pages/Investigate/ZhiFa.vue"
import DangJi from "@/pages/Investigate/DangJi.vue"
import Abstractted from "@/pages/Abstractted/Abstractted.vue"

// 企业责任
import duty from "@/pages/Duty/duty.vue"

// 社会责任
import sjDuty from "@/pages/Duty/sjDuty.vue"
import csDuty from "@/pages/Duty/csDuty.vue"

//企业文化
import culture from "@/pages/Culture/culture.vue"


//党纪处分
import scdcdjcf1 from "@/pages/Copywriting/Scdc/scdcdjcf1.vue"
import scdcdjcf2 from "@/pages/Copywriting/Scdc/scdcdjcf2.vue"
import scdcdjcf3 from "@/pages/Copywriting/Scdc/scdcdjcf3.vue"
import scdcdjcf4 from "@/pages/Copywriting/Scdc/scdcdjcf4.vue"
import scdcdjcf5 from "@/pages/Copywriting/Scdc/scdcdjcf5.vue"
// 党纪详情
import Detail from '@/pages/Copywriting/Detail.vue'
// 思想详情
import SX from '@/pages/Risk/SX.vue'

import Detail1 from '@/pages/Investigate/Detail1.vue'
// 11
import Zz from '@/pages/Copywriting/Zz.vue'
import TL from '@/pages/Copywriting/TL.vue'
import GZ from '@/pages/Copywriting/GZ.vue'
import GD from '@/pages/Copywriting/GD.vue'
import BF from '@/pages/Copywriting/BF.vue'
import XZ from '@/pages/Copywriting/XZ.vue'
import GF from '@/pages/Copywriting/GF.vue'
import JS from '@/pages/Copywriting/JS.vue'
import XF from '@/pages/Copywriting/XF.vue'
import FG from '@/pages/Copywriting/FG.vue'
import FL from '@/pages/Copywriting/FL.vue'
import XZ1 from '@/pages/Copywriting/XZ1.vue'
import BW from '@/pages/Copywriting/BW.vue'
import SF from '@/pages/Copywriting/SF.vue'
import XTS from '@/pages/Copywriting/XTS.vue'
import GC from '@/pages/Copywriting/GC.vue'
import ZG from '@/pages/Copywriting/ZG.vue'
import XS from '@/pages/Copywriting/XS.vue'
import SS from '@/pages/Copywriting/SS.vue'
import Yi from '@/pages/Copywriting/Yi.vue'
import Er from '@/pages/Copywriting/Er.vue'
import San from '@/pages/Copywriting/San.vue'
//写死的跳转文件
//清风论坛
import BannerTest1 from "@/pages/Copywriting/Qflt/QfltYlkt/BannerTest1.vue"
import BannerTest2 from "@/pages/Copywriting/Qflt/QfltYlkt/BannerTest2.vue"
import BannerTest3 from "@/pages/Copywriting/Qflt/QfltYlkt/BannerTest3.vue"
import ylkt4 from "@/pages/Copywriting/Qflt/QfltYlkt/ylkt4.vue"
import ylkt5 from "@/pages/Copywriting/Qflt/QfltYlkt/ylkt5.vue"
import ylkt6 from "@/pages/Copywriting/Qflt/QfltYlkt/ylkt6.vue"
import ylkt7 from "@/pages/Copywriting/Qflt/QfltYlkt/ylkt7.vue"
import ylkt8 from "@/pages/Copywriting/Qflt/QfltYlkt/ylkt8.vue"
import xxtr1 from "@/pages/Copywriting/Qflt/QfltTszsXxtr/xxtr1.vue"
import xxtr2 from "@/pages/Copywriting/Qflt/QfltTszsXxtr/xxtr2.vue"
import xxtr3 from "@/pages/Copywriting/Qflt/QfltTszsXxtr/xxtr3.vue"
import xxtr4 from "@/pages/Copywriting/Qflt/QfltTszsXxtr/xxtr4.vue"
import xxtr5 from "@/pages/Copywriting/Qflt/QfltTszsXxtr/xxtr5.vue"
import wzzj1 from "@/pages/Copywriting/Qflt/QfltTszsWzzj/wzzj1.vue"
import wzzj2 from "@/pages/Copywriting/Qflt/QfltTszsWzzj/wzzj2.vue"
import wzzj3 from "@/pages/Copywriting/Qflt/QfltTszsWzzj/wzzj3.vue"
import wzzj4 from "@/pages/Copywriting/Qflt/QfltTszsWzzj/wzzj4.vue"
import wzzj5 from "@/pages/Copywriting/Qflt/QfltTszsWzzj/wzzj5.vue"
import sjjy1 from "@/pages/Copywriting/Qflt/Sjjy/sjjy1.vue"
import sjjy2 from "@/pages/Copywriting/Qflt/Sjjy/sjjy2.vue"
import sjjy3 from "@/pages/Copywriting/Qflt/Sjjy/sjjy3.vue"
import sjjy4 from "@/pages/Copywriting/Qflt/Sjjy/sjjy4.vue"
import sjjy5 from "@/pages/Copywriting/Qflt/Sjjy/sjjy5.vue"
//cyc到此结束
// 文章详情
import DetailText from "@/pages/Detail-text/DetailText.vue"
import DetailStudy from "@/pages/Detail-text/DetailStudy.vue"
import DetailArmod from "@/pages/Detail-text/DetailArmod.vue"
import DetailEducation from "@/pages/Detail-text/DetailEducation.vue"
import DetailBanner from "@/pages/Detail-text/DetailBanner.vue"
import { store } from '@/store/store.js'
Vue.use(Router)


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  // mode: 'history',
  routes: [{
    name: "archives",
    path: "/archives",
    component: Archives,
    redirect: "/archives/leading",
    children: [{
      path: "leading",
      name: "leading",
      component: Leading
    },
    {
      path: "organization",
      name: "organization",
      component: Organization
    }
    ]
  },

  {
    name: "pageDetails",
    path: "/page-details/:id",
    component: () => import('@/components/PageDetails/index')
  },

  // 社会责任
  {
    name: "Duty",
    path: "/Duty",
    component: duty
  },
  {
    name: "sjDuty",
    path: "/sjDuty",
    component: sjDuty
  },
  {
    name: "csDuty",
    path: "/csDuty",
    component: csDuty
  },
  // 企业文化
  {
    name: "culture",
    path: "/culture",
    component: culture
  },
  {
    name: "DetailText",
    path: "/DetailText",
    component: DetailText
  },
  {
    name: "DetailArmod",
    path: "/DetailArmod",
    component: DetailArmod
  },
  {
    name: "DetailStudy",
    path: "/DetailStudy",
    component: DetailStudy
  },
  {
    name: "DetailEducation",
    path: "/DetailEducation",
    component: DetailEducation
  },
  {
    name: "DetailBanner",
    path: "/DetailBanner",
    component: DetailBanner
  },
  {
    name: "home",
    path: "/",
    component: Home
  },
  {
    name: "forum",
    path: "/forum",
    component: Forum,
    redirect: "/forum/forumClassroom",
    children: [{
      path: "forumClassroom",
      name: "forumClassroom",
      component: ForumClassroom,
      // beforeEnter: (to, from, next) => {
      //   // ...
      //   if (from.name === "TextEditor" || from.name === "BianJi") {
      //     store.commit("PortalManagement/HOME_ACTIVE", "second")
      //     // console.log(from.name,"子项进来")
      //   } else {
      //     store.commit("PortalManagement/HOME_ACTIVE", "first")
      //     // console.log(from.name,"外部过来")
      //   }
      //   next()
      // }
    },

    {
      path: "forumOutside",
      name: "forumOutside",
      component: ForumOutside,
      beforeEnter: (to, from, next) => {
        // ...
        if (from.name === "DetailArmod") {
          store.commit("SET_OUTSIDE_ACTIVE", "second")
          // console.log(from.name,"子项进来")
        } else {
          store.commit("SET_OUTSIDE_ACTIVE", "first")
          // console.log(from.name,"外部过来")
        }
        next()
      }
    },
    {
      path: "all/:navigationId/:type",
      name: "all",
      component: () => import('@/pages/Forum/all.vue'),
      beforeEnter: (to, from, next) => {
        // ...
        if (from.name === "DetailArmod") {
          store.commit("SET_OUTSIDE_ACTIVE", "second")
          // console.log(from.name,"子项进来")
        } else {
          store.commit("SET_OUTSIDE_ACTIVE", "first")
          // console.log(from.name,"外部过来")
        }
        next()
      }
    },
    {
      path: "forumWarning",
      name: "forumWarning",
      component: ForumWarning
    },

    ]
  },
  {
    name: "companyIntro",
    path: "/companyIntro",
    component: CompanyIntro,
    redirect: "/companyIntro/companyIntro",
    children: [{
      path: '/companyIntro/companyIntro',
      name: 'companyIntro',
      component: CompanyIntro
    },]
  },
  {
    name: "Detail",
    path: "/Detail",
    component: Detail
  },
  {
    name: "Risk",
    path: "/Risk",
    redirect: '/Risk/SiXiang',
    component: Risk,

    children: [{
      path: '/Risk/SiXiang',
      name: 'SiXiang',
      component: SiXiang,
      props: true
    },
    {
      path: '/Risk/ZhiDu',
      name: 'ZhiDu',
      component: ZhiDu
    },
    {
      path: '/Risk/ZhiZe',
      name: 'ZhiZe',
      component: ZhiZe
    }
    ]
  },
  {
    name: "productClassify",
    path: "/productClassify",
    redirect: 'ProductClassify/productClassify',
    component: ProductClassify,
    children: [{
      path: '/ProductClassify/productClassify',
      name: 'productClassify',
      component: ProductClassify
    },
    ]

  },
  {
    name: "contactUs",
    path: "/contactUs",
    redirect: '/ContactUs/contactUs',
    component: ContactUs,
    children: [{
      path: '/ContactUs/contactUs',
      name: 'contactUs',
      component: ContactUs
    },
    ]
  },
  {
    name: "Investigate",
    path: "/Investigate/:navigationId'",
    redirect: '/Investigate/ZhiJi/:navigationId',
    component: Investigate,
    children: [{
      path: '/Investigate/ZhiJi/:navigationId',
      name: 'ZhiJi',
      component: ZhiJi
    },
    {
      path: '/Investigate/ZhiFa',
      name: 'ZhiFa',
      component: ZhiFa
    },
    {
      path: '/Investigate/DangJi',
      name: 'DangJi',
      component: DangJi
    }
    ]
  },
  {
    name: "Abstractted",
    path: "/Abstractted",
    component: Abstractted
  },
  {
    name: "Text",
    path: "/Text",
    component: Text
  },
  //cyc静态页面路由
  { //轮播图链接地址1
    path: "/BannerTest1",
    name: "/BannerTest1",
    component: BannerTest1
  },
  { //轮播图链接地址1
    path: "/BannerTest2",
    name: "/BannerTest2",
    component: BannerTest2
  },
  { //轮播图链接地址1
    path: "/BannerTest3",
    name: "/BannerTest3",
    component: BannerTest3
  },
  // 党纪详情
  {
    name: "Detail",
    path: "/Detail/",
    component: Detail,

  },
  // 思想详情
  {
    name: "SX",
    path: "/SX/:id",
    component: SX,
    props: true
  },
  {
    name: "Detail1",
    path: "/Detail1",
    component: Detail1
  },
  // 111
  {
    name: "Zz",
    path: "/Zz",
    component: Zz
  },
  {
    name: "TL",
    path: "/TL",
    component: TL
  },
  {
    name: "GZ",
    path: "/GZ",
    component: GZ
  },
  {
    name: "GD",
    path: "/GD",
    component: GD
  },
  {
    name: "BF",
    path: "/BF",
    component: BF
  },
  {
    name: "XZ",
    path: "/XZ",
    component: XZ
  },
  {
    name: "GF",
    path: "/GF",
    component: GF
  },
  {
    name: "JS",
    path: "/JS",
    component: JS
  },
  {
    name: "XF",
    path: "/XF",
    component: XF
  },
  {
    name: "FG",
    path: "/FG",
    component: FG
  },
  {
    name: "FL",
    path: "/FL",
    component: FL
  },
  {
    name: "XZ1",
    path: "/XZ1",
    component: XZ1
  },
  {
    name: "BW",
    path: "/BW",
    component: BW
  },
  {
    name: "SF",
    path: "/SF",
    component: SF
  },
  {
    name: "XTS",
    path: "/XTS",
    component: XTS
  },
  //北京动态，区县动态
  {
    name: "GC",
    path: "/GC",
    component: GC
  },
  {
    name: "ZG",
    path: "/ZG",
    component: ZG
  },
  {
    name: "XS",
    path: "/XS",
    component: XS
  },
  {
    name: "SS",
    path: "/SS",
    component: SS
  },
  {
    name: "GC",
    path: "/GC",
    component: GC
  },
  {
    name: "Yi",
    path: "/Yi",
    component: Yi
  },
  {
    name: "Er",
    path: "/Er",
    component: Er
  },
  {
    name: "San",
    path: "/San",
    component: San
  },
  {//清风论坛开始部分（静态页面写死）
    name: "ylkt4",
    path: "/ylkt4",
    component: ylkt4
  },
  {
    name: "ylkt5",
    path: "/ylkt5",
    component: ylkt5
  },
  {
    name: "ylkt6",
    path: "/ylkt6",
    component: ylkt6
  },
  {
    name: "ylkt7",
    path: "/ylkt7",
    component: ylkt7
  },
  {
    name: "ylkt8",
    path: "/ylkt8",
    component: ylkt8
  },
  {
    name: "xxtr1",
    path: "/xxtr1",
    component: xxtr1
  },
  {
    name: "xxtr2",
    path: "/xxtr2",
    component: xxtr2
  },
  {
    name: "xxtr3",
    path: "/xxtr3",
    component: xxtr3
  },
  {
    name: "xxtr4",
    path: "/xxtr4",
    component: xxtr4
  },
  {
    name: "xxtr5",
    path: "/xxtr5",
    component: xxtr5
  },
  {
    name: "wzzj1",
    path: "/wzzj1",
    component: wzzj1
  },
  {
    name: "wzzj2",
    path: "/wzzj2",
    component: wzzj2
  },
  {
    name: "wzzj3",
    path: "/wzzj3",
    component: wzzj3
  },
  {
    name: "wzzj4",
    path: "/wzzj4",
    component: wzzj4
  },
  {
    name: "wzzj5",
    path: "/wzzj5",
    component: wzzj5
  },
  {
    name: "sjjy1",
    path: "/sjjy1",
    component: sjjy1
  },
  {
    name: "sjjy2",
    path: "/sjjy2",
    component: sjjy2
  },
  {
    name: "sjjy3",
    path: "/sjjy3",
    component: sjjy3
  },
  {
    name: "sjjy4",
    path: "/sjjy4",
    component: sjjy4
  },
  {
    name: "sjjy5",
    path: "/sjjy5",
    component: sjjy5
  },
  //党纪处分
  {
    name: "scdcdjcf1",
    path: "/scdcdjcf1",
    component: scdcdjcf1
  },
  {
    name: "scdcdjcf2",
    path: "/scdcdjcf2",
    component: scdcdjcf2
  },
  {
    name: "scdcdjcf3",
    path: "/scdcdjcf3",
    component: scdcdjcf3
  },
  {
    name: "scdcdjcf4",
    path: "/scdcdjcf4",
    component: scdcdjcf4
  },
  {
    name: "scdcdjcf5",
    path: "/scdcdjcf5",
    component: scdcdjcf5
  },

  //cyc静态页面到此结束
  {
    path: "*",
    redirect: "/"
  }
  ]
})
